import { NavLink, useNavigate } from 'react-router-dom';
import { clearAuthSession, getAuthUser, isAdminUser, isUserLoggedIn } from '../../utils/auth';
import IconBadge from './IconBadge';
import digioneLogo from '../../digioneLogo_Updated.png';

function HeaderBar() {
  const navigate = useNavigate();
  const showTabs = isUserLoggedIn();
  const isAdmin = isAdminUser();
  const authUser = getAuthUser();

  const handleAuthAction = () => {
    if (!showTabs) {
      navigate('/login');
      return;
    }

    clearAuthSession();
    navigate('/login');
  };

  return (
    <header className="helpdesk-header">
      <div
        className={`helpdesk-header__inner ${!showTabs ? 'helpdesk-header__inner--public' : ''}`.trim()}
      >
        <div className="helpdesk-header__left">
          <button
            type="button"
            className="helpdesk-header__brand"
            onClick={() => navigate('/')}
          >
            <span className="helpdesk-header__logo" aria-hidden="true">
              <img src={digioneLogo} alt="digione helpdesk logo" />
            </span>
            <p>DigiOne Helpdesk</p>
          </button>

          {showTabs ? (
            <nav className="helpdesk-header__tabs" aria-label="Dashboard tabs">
              <NavLink
                to="/knowledge-base"
                className={({ isActive }) =>
                  `helpdesk-header__tab ${isActive ? 'helpdesk-header__tab--active' : ''}`.trim()
                }
              >
                Article Management
              </NavLink>
              {isAdmin ? (
                <NavLink
                  to="/admin/announcements"
                  className={({ isActive }) =>
                    `helpdesk-header__tab ${isActive ? 'helpdesk-header__tab--active' : ''}`.trim()
                  }
                >
                  Announcement Management
                </NavLink>
              ) : null}
              {isAdmin ? (
                <NavLink
                  to="/admin/users"
                  className={({ isActive }) =>
                    `helpdesk-header__tab ${isActive ? 'helpdesk-header__tab--active' : ''}`.trim()
                  }
                >
                  User Management
                </NavLink>
              ) : null}
            </nav>
          ) : null}
        </div>

        <div className="helpdesk-header__actions" aria-label="Account actions">
          <button className="icon-button" type="button" aria-label="Notifications">
            <IconBadge icon="bell" />
          </button>
          {showTabs ? (
            <>
              <span className="helpdesk-header__user">
                {authUser?.name || authUser?.email || 'Admin User'}
              </span>
              <button className="helpdesk-header__auth-btn" type="button" onClick={handleAuthAction}>
                Logout
              </button>
            </>
          ) : (
            <button className="helpdesk-header__login-btn" type="button" onClick={handleAuthAction}>
              Admin Portal Login
            </button>
          )}
        </div>
      </div>
    </header>
  );
}

export default HeaderBar;
